<template>
  <div class="card cart-summary d-flex flex-column">
    <div class="card-header border-bottom bg-light">
      <h5 class="card-title fw-bold mb-0">🛒 Panier</h5>
    </div>

    <div class="card-body flex-grow-1 overflow-auto px-3 py-2">
      <div v-if="items.length === 0" class="text-center text-muted py-5">
        <i class="fe fe-shopping-cart mb-2" style="font-size: 24px;"></i><br>
        Aucun article dans le panier.
      </div>

      <div v-else class="cart-items-list">
        <div
            v-for="item in items"
            :key="item.id"
            class="cart-item d-flex align-items-center justify-content-between mb-3"
        >
          <div class="d-flex align-items-center">
            <img
                :src="item.imageUrl || placeholderImage"
                class="avatar-sm br-5 me-3"
                alt="product"
            />
            <div>
              <div class="fw-semibold">{{ item.name }}</div>
              <small class="text-muted">${{ item.referencePrice.toFixed(2) }} x {{ item.quantity }}</small>
            </div>
          </div>

          <div class="d-flex align-items-center gap-2">
            <input
                type="number"
                v-model.number="item.quantity"
                min="1"
                class="form-control form-control-sm qty-input"
                @change="emitQty(item)"
            />
            <button class="btn btn-sm btn-outline-danger" @click="$emit('remove-item', item.id)">
              <i class="fe fe-trash-2"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-3 py-2 bg-light border-top" v-if="items.length">
      <div class="d-flex justify-content-between mb-2">
        <span>Shipping</span>
        <span>
        ${{ shippingCost.toFixed(2) }}
        <i class="fe fe-edit ms-2 text-primary cursor-pointer"
           @click="$refs.payModal.open('shipping', { amount: shippingCost })"></i>
      </span>
      </div>

      <div class="d-flex justify-content-between mb-2">
        <span>Tax</span>
        <span>
        ${{ taxAmountComputed.toFixed(2) }}
        <i class="fe fe-edit ms-2 text-primary cursor-pointer"
           @click="$refs.payModal.open('tax', { taxMode, taxValue })"></i>
      </span>
      </div>

      <div class="d-flex justify-content-between mb-2">
        <span>Coupon</span>
        <span>
        -${{ couponAmount.toFixed(2) }}
        <i class="fe fe-edit ms-2 text-primary cursor-pointer"
           @click="$refs.payModal.open('coupon', { amount: couponAmount })"></i>
      </span>
      </div>

      <div class="d-flex justify-content-between mb-2">
        <span>Discount</span>
        <span>
        -${{ discountAmount.toFixed(2) }}
        <i class="fe fe-edit ms-2 text-primary cursor-pointer"
           @click="$refs.payModal.open('discount', { amount: discountAmount })"></i>
      </span>
      </div>
    </div>

    <PaymentEditModal
        ref="payModal"
        :subtotal="subtotal"
        @save="onPaymentEditSave"
    />

    <div v-if="items.length > 0" class="cart-total px-3 py-2 border-top bg-white d-flex justify-content-between fw-bold fs-5">
      <span>Total :</span>
      <span>${{ total.toFixed(2) }}</span>
    </div>
  </div>
</template>

<script>
  import PaymentEditModal from "../modals/ModalPaiementEdit.vue";

  export default {
    name: "CartSummary",
    components: {PaymentEditModal},
    props: {
      items: {
        type: Array,
        required: true
      },
      total: {
        type: Number,
        default: 0
      },
      client: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        placeholderImage: 'https://www.tiffincurry.ca/wp-content/uploads/2021/02/default-product.png',
        showEditModal: false,
        editField: null,
        editValue: 0,
        shippingCost: 0,
        couponAmount: 0,
        discountAmount: 0,
        taxMode: 'NONE',     // NONE | PERCENT | AMOUNT
        taxValue: 0
      };
    },
    computed: {
      subtotal() { return this.total || 0; },
      taxAmountComputed() {
        if (this.taxMode === 'PERCENT') return (this.subtotal * (this.taxValue || 0)) / 100;
        if (this.taxMode === 'AMOUNT')  return this.taxValue || 0;
        return 0;
      },
      finalTotal() {
        return this.subtotal + this.shippingCost + this.taxAmountComputed - this.couponAmount - this.discountAmount;
      }
    },
    methods: {
      emitQty(item) {
        this.$emit('update-qty', {
          id: item.id,
          quantity: item.quantity
        });
      },
      onPaymentEditSave(payload) {
        switch (payload.field) {
          case 'shipping': this.shippingCost   = payload.amount ?? 0; break;
          case 'coupon':   this.couponAmount   = payload.amount ?? 0; break;
          case 'discount': this.discountAmount = payload.amount ?? 0; break;
          case 'tax':
            this.taxMode  = payload.taxMode || 'NONE';
            this.taxValue = payload.taxValue || 0;
            break;
        }
      }
    }
  };
</script>

<style scoped>
.qty-input {
  width: 60px;
}

.cart-summary {
  height: 80vh;
  display: flex;
  flex-direction: column;
}

.cart-summary .card-body {
  flex-grow: 1;
  overflow-y: auto;
}

.cart-item {
  border-bottom: 1px solid #f1f1f1;
  padding-bottom: 0.5rem;
}

.cart-total {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>

